var map = {
	"./1.svg": 1049,
	"./10.svg": 1050,
	"./11.svg": 1051,
	"./12.svg": 1052,
	"./2.svg": 1053,
	"./3.svg": 1054,
	"./4.svg": 1055,
	"./5.svg": 1056,
	"./6.svg": 1057,
	"./7.svg": 1058,
	"./8.svg": 1059,
	"./9.svg": 1060,
	"./avatar-1.jpg": 756,
	"./avatar-2.jpg": 757,
	"./avatar-3.jpg": 758,
	"./avatar-4.jpg": 759,
	"./avatar-5.jpg": 1061,
	"./backgroundSvg.zip": 1062,
	"./bg.png": 1063,
	"./logo.png": 138,
	"./new.svg": 1064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 755;